import { render, staticRenderFns } from "./BoxApps.vue?vue&type=template&id=e2f18f60&scoped=true&"
import script from "./BoxApps.vue?vue&type=script&lang=js&"
export * from "./BoxApps.vue?vue&type=script&lang=js&"
import style0 from "./BoxApps.vue?vue&type=style&index=0&id=e2f18f60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f18f60",
  null
  
)

export default component.exports